import { jsx as _jsx } from "react/jsx-runtime";
import { FeedbackMessage } from "@gemini/ui";
import { Box } from "@gemini/core";
import { useI18n } from "@/shared/hooks";
export const ContactFormValidationMessage = ({ testId, errors, }) => {
    const { t } = useI18n();
    if (Object.keys(errors).length < 3) {
        return null;
    }
    return (_jsx(Box, { marginBottom: "spacing.24", children: _jsx(FeedbackMessage, { testId: `${testId}.FeedbackMessage`, variant: "error", title: t("contact.form.validation_error.title"), children: Object.entries(errors).map(([key]) => {
                return _jsx("li", { children: t(`contact.form.${key.toLowerCase()}`) }, key);
            }) }) }));
};
